import { render } from "./whiteList_ip.vue?vue&type=template&id=6f31059e&scoped=true"
import script from "./whiteList_ip.vue?vue&type=script&lang=js"
export * from "./whiteList_ip.vue?vue&type=script&lang=js"

import "./whiteList_ip.vue?vue&type=style&index=0&id=6f31059e&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f31059e"]])

export default __exports__